import apiUrl from "./config/config";
import axios from "axios";

class navigationApi {

  static async getNavigation()
  {

    try
    {

      const response = await axios(apiUrl + "navigation");

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

}

export default navigationApi;
